import { Box, Typography } from "@mui/material";
import MainModal from "components/MainModal";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";

const RCAConfirmDeleteModal = ({
    open,
    onClose,
    onDeleteItem,
    title,
    warning,
    confirm,
    canDelete,
    children,
    bodyClassname,
}: {
    open: boolean;
    onClose: () => void;
    onDeleteItem: () => Promise<void>;
    title: string;
    warning: string;
    confirm: string;
    canDelete?: boolean;
    children?: JSX.Element;
    bodyClassname?: string;
}) => {
    const mainClasses = useRCAMainStyles();

    const handleOnClose = () => {
        onClose();
    };

    return (
        <MainModal
            isOpen={open}
            onClose={handleOnClose}
            title={title}
            showCloseButton
            customModalStyles={{ width: 600 }}
            onOkButtonClick={async () => {
                await onDeleteItem();
                handleOnClose();
            }}
            okButton={confirm}
            okButtonColor="error"
            disableOkButton={canDelete}
        >
            <Box className={`${bodyClassname ? bodyClassname : mainClasses.contentCardContent}`}>
                <Typography variant="body1">{warning}</Typography>
                {children}
            </Box>
        </MainModal>
    );
};

export default RCAConfirmDeleteModal;
